import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {useFilterContext, useFilterDispatch} from '../contexts/FilterContextProvider';
import {updateHistory, checkForFilters} from '../utils/data';

function RemoveMapSelection() {
    const filters = useFilterContext();
    const filterDispatch = useFilterDispatch();
    const history = useHistory();
    let newFilters = JSON.parse(JSON.stringify(filters));

    const removeMapPoint = (e) => {
        newFilters.mapPoint = "";
        newFilters.page = checkForFilters(newFilters) ? "" : "projects";
        filterDispatch({
            type: "mapPoint",
            payload: "",
            pagePayload: newFilters.page,
            updatedFilterPayload: "removedMapPoint",
            selectedForSnapshotPayload: filters.selectedForSnapshot !== "" ? filters.selectedForSnapshot : "",
            extentPayload: filters.extent ? filters.extent : null
        });
        updateHistory(history, newFilters);
    };

    return (
        <div id="removeMapSelection" className={"esri-widget--button esri-component" + (filters.mapPoint !== "" ? "" : " hide")} onClick={(e) => removeMapPoint(e)}>
            <div className="esri-icon">
                <FontAwesomeIcon icon={faTimes} aria-label="Remove Map Selection" />&nbsp;&nbsp;Remove map selection
            </div>
        </div>
    );
}

export default memo(RemoveMapSelection);